import { css } from '@emotion/core';

export const extendsToEdge = css`
  margin: 0 calc(50% - 50vw);
`;
